/* istanbul ignore file
TODO: Remove ignore and add tests as part of DMD-4934 */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useFormContext } from 'react-hook-form';

import { useHasClover } from '@getbento/payments/hooks/usePayments';
import { useHasCheckSplittingFeature } from 'reservations/account/hooks/featureFlags';
import { useIsChecklessPaymentsEnabled } from 'reservations/account/providers/ConfigProvider';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import {
  useBookingChecklessPayment,
  useBookingDetails
} from 'reservations/booking/providers/BookingProvider';
import {
  useHasStarted,
  useIsCanceled
} from 'reservations/booking/providers/BookingProvider';
import { useBookingEmail } from 'reservations/booking/providers/BookingProvider';
import { useIsCheckSplittingEnabled } from 'reservations/booking/providers/BookingProvider';
import { ChecklessEnrollmentButtonsContainer } from 'reservations/checklessPayments/components/ChecklessEnrollmentButtonsContainer';
import { ChecklessEnrollmentDetailsV2 } from 'reservations/checklessPayments/components/ChecklessEnrollmentDetailsV2';
import BookingConfirmationDetailCard from 'reservations/confirmation/components/BookingConfirmationDetailCard';
import BookingConfirmationDetailText from 'reservations/confirmation/components/BookingConfirmationDetailText';
import ChecklessPaymentsEnrollmentDetails from 'reservations/confirmation/components/ChecklessPaymentsEnrollmentDetails';
import { useDinerAccount } from 'reservations/dinerAccount/hooks/useDinerAccount';
import { DEFAULT_CHECKLESS_MODULE_CONTEXT } from 'reservations/preDining/constants';

type Props = {
  context?: {
    title: string;
    description: string;
    buttonText: string;
  };
};

const ChecklessPaymentsModule = ({
  context = DEFAULT_CHECKLESS_MODULE_CONTEXT
}: Props) => {
  const { setValue } = useFormContext();
  const email = useBookingEmail();
  const { optInChecklessPayments } = useBookingChecklessPayment();
  const isChecklessPaymentsEnabled = useIsChecklessPaymentsEnabled();
  const isCheckSplittingEnabled = useIsCheckSplittingEnabled();
  const hasCheckSplittingFeature = useHasCheckSplittingFeature();
  const isCanceled = useIsCanceled();
  const hasStarted = useHasStarted();
  const {
    hasPaymentMethods,
    isDinerAccountAuthenticated,
    dinerAccountExists,
    setBeginAuthParams
  } = useDinerAccount();
  const hasClover = useHasClover();
  const { open } = useModal();
  const { dateAndTime } = useBookingDetails();
  const now = new Date();
  const reservationDateAndTime = new Date(dateAndTime);
  // If reservation datetime is in the past, we hide enrollment in checkless payments.
  // TODO: Ideally we want to use the SEATED status but currently 7rooms does not send it unless a diner is enrolled.
  const reservationDateTimeHasPassed = reservationDateAndTime <= now;

  const { buttonText, description, title } = context;

  const handleEnroll = () => {
    setValue('optInChecklessPayments', true);
    const shouldAuth = dinerAccountExists && !isDinerAccountAuthenticated;
    const startModal = hasPaymentMethods
      ? ModalType.ChecklessSelectCard
      : ModalType.ChecklessAddCard;
    if (shouldAuth) {
      setBeginAuthParams(email);
      open(ModalType.ChecklessOtp, { nextModal: startModal });
    } else {
      open(startModal);
    }
  };

  if (
    !isChecklessPaymentsEnabled ||
    !isCheckSplittingEnabled ||
    !hasClover ||
    hasStarted ||
    isCanceled ||
    reservationDateTimeHasPassed
  ) {
    return null;
  }

  return (
    <BookingConfirmationDetailCard header={title}>
      {!(hasCheckSplittingFeature && optInChecklessPayments) && (
        <BookingConfirmationDetailText text={description} />
      )}
      {optInChecklessPayments ? (
        hasCheckSplittingFeature ? (
          <ChecklessEnrollmentDetailsV2 />
        ) : (
          <Box sx={{ width: '100%' }}>
            <ChecklessPaymentsEnrollmentDetails />
          </Box>
        )
      ) : hasCheckSplittingFeature ? (
        <ChecklessEnrollmentButtonsContainer buttonText={buttonText} />
      ) : (
        <Button onClick={handleEnroll}>{buttonText}</Button>
      )}
    </BookingConfirmationDetailCard>
  );
};

export default ChecklessPaymentsModule;
